module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 10-aa5b96cbbb6157b3e8c6c952e773aa48.jpg";